// src/lib/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsJson from "../translations.json";

// Converteer de flat structuur naar geneste i18next resources
const convertToNestedResources = (flatTranslations: Record<string, string>) => {
  const nested: any = {
    auth: {
      forgetPassword: flatTranslations.auth__forget_password?.replace(":link", "{{link}}") || "",
      welcome: flatTranslations.auth__welcome || "",
      loginText: flatTranslations.auth__login_text || "",
      label: {
        email: flatTranslations.auth__label_email || "",
        password: flatTranslations.auth__label_password || "",
      },
      noAccount: flatTranslations.auth__no_account || "",
      submit: flatTranslations.auth__submit || "",
      orDivider: flatTranslations.auth__or_divider || "of",
      microsoftButton: flatTranslations.auth__microsoft_button || "Inloggen met Microsoft",
    },
    dibretto: {
      loggedIn: flatTranslations.dibretto__logged_in || "",
      settings: {
        header: flatTranslations.dibretto__settings_header || "",
        intro: flatTranslations.dibretto__settings_intro || "",
        label: {
          translate: flatTranslations.dibretto__settings_label_Translate || "",
          simplify: flatTranslations.dibretto__settings_label_Simplify || "",
          readOutLoud: flatTranslations.dibretto__settings_label_ReadOutLoud || "",
          secureWithPin: flatTranslations.dibretto__settings_label_SecureWithPIN || "",
        },
        process: {
          text: flatTranslations.dibretto__settings_process_text || "",
          button: flatTranslations.dibretto__settings_process_button || "",
          buttonLoading: flatTranslations.dibretto__settings_process_button_loading || "",
        },
        processed: {
          text: flatTranslations.dibretto__settings_processed_text || "",
        },
        mailMergeDisclaimer: flatTranslations.dibretto__settings_mail_merge_disclaimer || "",
      },
      pincode: {
        header: flatTranslations.dibretto__pincode_header || "",
        intro: flatTranslations.dibretto__pincode_intro || "",
        label: flatTranslations.dibretto__pincode_label || "",
        warning: flatTranslations.dibretto__pincode_warning || "",
      },
      footer: {
        learningCentre: flatTranslations.dibretto__footer_learning_centre || "",
        helpdesk: flatTranslations.dibretto__footer_helpdesk || "",
        logout: flatTranslations.dibretto__footer_logout || "",
        suggestImprovement: flatTranslations.dibretto__footer_suggest_improvement || "",
      },
    },
    document: {
      alreadyProcessed: flatTranslations.document_already_processed || "",
    },
  };
  return nested;
};

// Converteer alle talen naar i18next resources formaat
export const resources: Record<string, { translation: any }> = {};
for (const [lang, translations] of Object.entries(translationsJson)) {
  resources[lang] = {
    translation: convertToNestedResources(translations as Record<string, string>),
  };
}

// Detecteer taal via Office context of browser language
const detectLanguage = (): string => {
  if (typeof Office !== "undefined" && Office.context?.displayLanguage) {
    const officeLang = Office.context.displayLanguage;
    // Check of de taal ondersteund wordt
    if (resources[officeLang]) {
      return officeLang;
    }
    // Probeer alleen de taalcode (bijv. "nl" van "nl-NL")
    const langCode = officeLang.split("-")[0];
    const supportedLang = Object.keys(resources).find((key) => key.startsWith(langCode));
    if (supportedLang) {
      return supportedLang;
    }
  }
  // Fallback naar browser language
  const browserLang = navigator.language || navigator.languages?.[0] || "en-US";
  const browserLangCode = browserLang.split("-")[0];
  const supportedLang = Object.keys(resources).find((key) => key.startsWith(browserLangCode));
  return supportedLang || "en-US";
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: "en-US",
  interpolation: { escapeValue: false }, // HTML support
});

export default i18n;
